"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeScriptUtility_1 = require("./common/TypeScriptUtility");
/**
 * Smart constructor for creating a just value.
 *
 * @param value - The just value.
 */
function just(value) {
    return {
        type: 'Just',
        value: value
    };
}
exports.just = just;
/**
 * A value for representing nothing.
 */
exports.nothing = {
    type: 'Nothing'
};
/**
 * Higher-order helper function for maybe values.
 *
 * @param f - Function to apply to a just value.
 * @param t - Default value to return when applied to nothing.
 */
function maybe(f, t) {
    return function (m) {
        switch (m.type) {
            case 'Just': return f(m.value);
            case 'Nothing': return t;
            default: return TypeScriptUtility_1.assertNever(m);
        }
    };
}
exports.maybe = maybe;
/**
 * Returns a just value or throws an exception if given nothing.
 *
 * @param m - Maybe value.
 * @throws Error if given nothing.
 */
function fromJust(m) {
    switch (m.type) {
        case 'Just': return m.value;
        default: throw new Error('Nothing');
    }
}
exports.fromJust = fromJust;
/**
 * Returns a just value or a given default if applied to nothing.
 *
 * @param t - Default value.
 */
function fromMaybe(t) {
    return maybe(function (v) { return v; }, t);
}
exports.fromMaybe = fromMaybe;
/**
 * Checks if a given maybe value is just.
 *
 * @param m - Maybe value to check.
 */
function isJust(m) {
    return maybe(function (_) { return true; }, false)(m);
}
exports.isJust = isJust;
/**
 * Checks if a given maybe value is nothing.
 *
 * @param m - Maybe value to check.
 */
function isNothing(m) {
    return !isJust(m);
}
exports.isNothing = isNothing;
//# sourceMappingURL=Maybe.js.map